import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import FileUtils, {ContentType} from '../../../../../../../core/services/file-utils';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import {CreateContractService} from '../../../../../../../core/services/create-contract.service';
import {CommonService} from '../../../../../../../core/services/common.service';
import {debounceTime, distinctUntilChanged, takeUntil, tap} from 'rxjs/operators';
import {DocumentTypeService} from '../../../../../../../core/services/document-type.service';
import {ReplaySubject, Subscription} from 'rxjs';
import {WarningComponent} from '../../../../../../../shared/components/warning/warning.component';
import {Router} from '@angular/router';
import {getLocaleFirstDayOfWeek, Location} from '@angular/common';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {DigitalContractService} from '../../../../../../../core/services/digital-contract.service';
import { format } from 'date-fns';
import {Common} from 'src/app/core/constants/common';
import {ViewContractBusinessComponent} from '../view-contract/view-contract-business.component';
import {ErrorCode} from 'src/app/core/constants/error-code';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { EnvService } from 'src/app/core/services/env.service';
import { TranslateService } from '@ngx-translate/core';
import { DocumentService } from 'src/app/core/services/document.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {EnumApproverStatus, EnumContractEnterpriseStatus} from "../../../../../../../core/constants/contract";
import {EnterpriseEntity} from "../../../../../../../core/class/enterpriseEntity";
import {
  AddCustomerDialogComponent
} from "../../../customer/customer/add-customer/add-customer-dialog/add-customer-dialog.component";
import {DocumentCustomerEntity} from "../../../../../../../core/class/document-customer-entity";
import {CustomerService} from "../../../../../../../core/services/customer.service";
import {AutoEnterpriseService} from "../../../../../../../core/services/auto-enterprise.service";
import {ViewContractComponent} from "../../contract-digitization/view-contract/view-contract.component";
import {
  ViewDocumentReferenceComponent
} from "../../../../../../../shared/components/view-document-reference/view-document-reference.component";
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

const FileUploadType = 1;
const LIMIT_SIZE = 10485760

@Component({
  selector: 'app-add-contract',
  templateUrl: './add-contract.component.html',
  styleUrls: ['./add-contract.component.scss']
})
export class AddContractDigitizationBusinessComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  @ViewChild('inputUpload', {read: '', static: false})
  inputUploadFile: ElementRef;

  mainFormAdd: FormGroup;

  pdfSrc;

  checkFocus = false;
  dataDocumentParent: any[] = [];
  RECORD_PARTY_SIGN: EnterpriseEntity[] = [];
  contractEnterpriseCreated = [];
  private customerDialog: MatDialogRef<AddCustomerDialogComponent>;
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  valueAddPartyOrder = 1;
  nzCheckLoadingParty = false;
  nzCheckLoadingParty1 = false;
  inputPartyValue: string;
  filteredPartyOptions = [];
  timeOutQueryServer = null;
  mapOfExpandData: { [key: string]: boolean } = {};
  inputInternalDocumentsValue:string;

  selectedDocumentTypeParent: any;

  serviceTypeCtrl = new FormControl(null);

  serviceTypes = [];

  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  language: string;

  filesUpload = [];

  filesNameHaveOrder = [];

  newFileOrders = [];

  contractAttachmentsNew = [];

  filesSrc = [];

  filesName = [];

  isViewParentContract = false;

  isShowParentList = true;

  contractView = {
    contractName: '',
    id: [],
    filesName: [],
    listFileSize: [],
    idDocument:'',
    checkMan:2,
    attachments:[]
  };

  subscriptions: Subscription = new Subscription();

  mode: string = 'create';

  featureStatus: boolean;

  statusBackup: boolean;

  activeFile = 0;

  isViewFull = false;

  docType = [];

  contractId = '';
  timeOutQueryServer1 = null;

  parentContracts = [];

  parentSelected = new FormControl();

  affiliateContract = [];

  isLoading = false;

  dateField = '';

  listParentHeight = 0;

  parentActive = -1;
  filesAttachment = [];
  filesAttachmentOld = [];
  mainFiles = []
  newFileAttachmentOrders = [];
  maxSize = 0;
  maxSizeSystem = 0;
  maxPerMainFile = 0;
  maxPerAttachFile = 0;
  mesage: string = '';
  contractStatus: any;
  BASE_URL = '';
  authorization: any;
  docInfos:any;
  markPdf: any
  userType: number;
  isShowUpdate: boolean = false;

  constructor(
    private fb: FormBuilder,
    private translateService:TranslateService,
    private documentService:DocumentService,
    private toastr: ToastrService,
    private message: Message,
    private createContractService: CreateContractService,
    public commonService: CommonService,
    private documentTypeService: DocumentTypeService,
    public autoEnterpriseService: AutoEnterpriseService,
    private customerService: CustomerService,
    private digitalContractService: DigitalContractService,
    private router: Router,
    private location: Location,
    private dialog: MatDialog,
    private digitalCertificateService: DigitalCertificateService,
    private env: EnvService
  ) {
    this.language = localStorage.getItem('__language') || 'vi';
    this.digitalContractService.keepFilter.next(true);
    this.blockUI.start();
    pdfDefaultOptions.renderInteractiveForms = false;
    this.BASE_URL = env.is_private_app ? env.private_api_endpoint : env.public_api_endpoint;
    this.BASE_URL += '/file/view/digital/view-file';
    localStorage.removeItem('saveContract')
    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
  }

  ngOnDestroy(): void {
    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }
  }

  @HostListener('document:click')
  parentFocusOut() {
    if (this.mainFormAdd) {
      this.focusOut('parentSelected');
    }
  }

  ngOnInit() {
    this.blockUI.start();
    const digitalFeature = JSON.parse(localStorage.getItem('featureStatus'));
    digitalFeature.map(item => {
      if (item.permission === 10) {
        this.featureStatus = item.status;
        this.statusBackup = item.statusBackup;
      }
    });

    const param = this.router.url.split('/');
    const mode = param.pop();

    switch (mode) {
      case 'view':
        this.mode = mode;
        this.blockUI.stop();
        break;
      case 'update':
        this.mode = mode;
        this.blockUI.stop();
        break;
    }
    localStorage.setItem("digitalBusinessContractCancel",this.mode);

    this.digitalContractService.checkBackup().subscribe(res => {
      if (res.message === 'OK') {
        this.statusBackup = false;
      }
      else {
        this.statusBackup = true;
        if (!this.featureStatus || (this.statusBackup && this.mode !== 'view')) {
          this.toastr.error(res.message);
          this.router.navigateByUrl('/home-enterprise/digital-business');
        }
      }
    })

    this.getMaxSize()
    this.initForm();
    this.documentTypeService.getServiceTypes(localStorage.getItem('enterpriseId')).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      this.serviceTypes = rs.data;
      this.docType = rs.data;
      this.filteredServiceTypes.next(rs.data.slice());
      this.createContractService.pdfSrc.next(null);

      if (this.mode !== 'create') {
        this.contractId = param.pop();
        this.initData(this.contractId);
      }
      this.blockUI.stop();
    });

  }

  initForm() {
    this.mainFormAdd = this.fb.group({
      id: new FormControl(''),
      docType: new FormControl('', Validators.required),
      docParent: new FormControl(''),
      docName: new FormControl('', [Validators.required, Validators.maxLength(100)]),
      docCode: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern(Common.DOCUMENT_CODE_PATTERN)]),
      effectiveDate: new FormControl('', Validators.required),
      expirationDate: new FormControl(''),
      description: new FormControl(''),
      allowReferenceCustomerView: new FormControl(false)
    });

    this.serviceTypeCtrl.valueChanges
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypeCtrl, this.filteredServiceTypes);
        });
  }

  getMaxSize(){
    const id = localStorage.getItem('enterpriseId')
    this.digitalCertificateService.getPermissionHSM(id).subscribe(res => {
      if(res && res.success){
        this.maxSize = res.data.maxSize > 0 ? res.data.maxSize : 10*1024*1024;
        this.maxSizeSystem = res.data.maxSizeSystem ? res.data.maxSizeSystem : 150*1024*1024;
        this.maxPerMainFile = res.data.maxPerMainFile ? res.data.maxPerMainFile : 150*1024*1024;
        this.maxPerAttachFile = res.data.maxPerAttachFile ? res.data.maxPerAttachFile : 150*1024*1024;
        this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)))
      }
    })
  }
  checkExistedInternalUser(id: string) {
    const existedList = this.dataDocumentParent.filter((e) => {
      return e.id === id;
    });

    return (existedList.length > 0);
  }
  checkExistedParty(enterpriseId: string, customerId: string) {
    const existedList = this.RECORD_PARTY_SIGN.filter(d => d.customerId === customerId)

    return existedList.length > 0;
  }

  get isFromSSO(){
    if( localStorage.getItem('isFromSSO') =='true'){
      return true
    }
    return false
  }

  public getCustomerById(id, isEdit = false, callback?: (customer) => void) {
    this.customerService.getCustomer(id).subscribe(rs => {
      if (rs != null && rs.data != null) {
        const customer: DocumentCustomerEntity = {
          customerAccountNumber: rs.data.accountNumber ? rs.data.accountNumber : '',
          customerAddress: rs.data.address ? rs.data.address : '',
          customerAdminUser: rs.data.adminUser ? rs.data.adminUser : '',
          customerAttachments: rs.data.attachments ? rs.data.attachments : '',
          customerBankBranch: rs.data.bankBranch ? rs.data.bankBranch : '',
          customerBankName: rs.data.bankName ? rs.data.bankName : '',
          customerBank: `${rs.data.bankName ? rs.data.bankName + ', ' : ''}${rs.data.bankBranch ? rs.data.bankBranch : ''}`,
          customerBirthday: rs.data.birthday ? this.commonService.formatDate(new Date(rs.data.birthday)) : null,
          customerCertificateId: rs.data.certificateId ? rs.data.certificateId : '',
          customerCertificateNo: rs.data.certificateNo && rs.data.customerType ? rs.data.certificateNo : '',
          customerCityId: rs.data.cityId ? rs.data.cityId : '',
          customerType: rs.data.customerType ? rs.data.customerType : '',
          customerDistrictId: rs.data.districtId ? rs.data.districtId : '',
          customerEmail: '',
          customerPhone: '',
          customerReceiverEmail: rs.data.email ? rs.data.email : '',
          customerEnterpriseId: rs.data.enterpriseId ? rs.data.enterpriseId : '',
          customerFax: rs.data.fax ? rs.data.fax : '',
          customerId: rs.data.customerId ? rs.data.customerId : '',
          customerIssuedAt: '',
          customerIssuedDate: '',
          customerIssuedDay: null,
          customerIssuedMonth: null,
          customerIssuedYear: null,
          customerName: rs.data.name ? rs.data.name : '',
          customerReceiverPhone: rs.data.phone ? rs.data.phone : '',
          customerPosition: rs.data.position ? rs.data.position : '',
          customerPrimaryEmail: rs.data.primaryEmail ? rs.data.primaryEmail : '',
          customerRepresentative: rs.data.representative
            ? this.commonService.capitalizeFirstLetter(rs.data.representative)
            : '',
          customerRepresentativeCertificateId: rs.data.representativeCertificateId ? rs.data.representativeCertificateId : '',
          customerRepresentativeCertificateNo: rs.data.representativeCertificateNo ? rs.data.representativeCertificateNo : '',
          customerRepresentativeIssuedAt: rs.data.representativeIssuedAt ? rs.data.representativeIssuedAt : '',
          customerRepresentativeIssuedDate: rs.data.representativeIssuedDate
            ? this.commonService.formatDate(new Date(rs.data.representativeIssuedDate))
            : null,
          customerSex: (typeof rs.data.sex !== 'undefined') ? (rs.data.sex ? 'Nam' : 'Nữ') : '',
          customerTaxCode: rs.data.taxCode ? rs.data.taxCode : '',
          customerWardId: rs.data.wardId ? rs.data.wardId : '',
          customerAddressUsing: rs.data.address ? rs.data.address : '',
          customerContacter: rs.data.name ? this.commonService.capitalizeFirstLetter(rs.data.name) : '',

          customerIndividualOrRepresentativeCertificate: rs.data.customerType === 10000
            ? rs.data.certificateNo
            : rs.data.representativeCertificateNo,
          customerIndividualOrRepresentativeIssuedAt: rs.data.customerType === 10000
            ? rs.data.issuedAt
            : rs.data.representativeIssuedAt,
          customerIndividualOrRepresentativeIssuedDate: rs.data.customerType === 10000
            ? this.commonService.formatDate(new Date(rs.data.issuedDate))
            : this.commonService.formatDate(new Date(rs.data.representativeIssuedDate)),
          customerIndividualOrRepresentativeIssuedDay: null,
          customerIndividualOrRepresentativeIssuedMonth: null,
          customerIndividualOrRepresentativeIssuedYear: null,
          customerIndividualOrRepresentativeIssuedShortYear: null,
          customerBusinessCertificateNo: rs.data.customerType !== 10000 ? rs.data.certificateNo : '',
          customerBusinessCertificateIssuedAt: rs.data.customerType !== 10000 ? rs.data.issuedAt : '',
          customerBusinessCertificateIssuedDate: rs.data.customerType !== 10000
            ? this.commonService.formatDate(new Date(rs.data.issuedDate))
            : '',
          customerBusinessCertificateIssuedDay: '',
          customerBusinessCertificateIssuedMonth: '',
          customerBusinessCertificateIssuedYear: '',
          customerTaxCode_01: '',
          customerTaxCode_02: '',
          customerTaxCode_03: '',
          customerTaxCode_04: '',
          customerTaxCode_05: '',
          customerTaxCode_06: '',
          customerTaxCode_07: '',
          customerTaxCode_08: '',
          customerTaxCode_09: '',
          customerTaxCode_10: '',
          customerTaxCode_11: '',
          customerTaxCode_12: '',
          customerTaxCode_13: '',
          customerTaxCode_14: '',
          customerContacterApartmantNumber: '',
          customerContacterStreetName: '',
          customerContacterGroup: '',
          customerContacterWard: '',
          customerContacterDistrict: '',
          customerContacterCity: '',
          customerContacterPhone: '',
          customerContacterEmail: '',
        }


        customer.customerEmail = rs.data.email ? rs.data.email : '';
        customer.customerPhone = rs.data.phone ? rs.data.phone : '';


        // If customer is enterprise
        if (customer.customerType !== 10000) {
          customer.customerIssuedAt = rs.data.issuedAt ? rs.data.issuedAt : '';
          customer.customerIssuedDate = rs.data.issuedDate ? this.commonService.formatDate(new Date(rs.data.issuedDate)) : null;
          customer.customerIssuedDay = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getDate()
            : null;
          customer.customerIssuedMonth = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getMonth() + 1
            : null;
          customer.customerIssuedYear = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getFullYear().toString()
            : null;
        } else {
          customer.customerIssuedAt = '';
          customer.customerIssuedDate = '';
          customer.customerIssuedDay = null;
          customer.customerIssuedMonth = null;
          customer.customerIssuedYear = null;

        }
        // Generate splitted customerTaxCode
        for (let i = 0; i < 14; i++) {
          const key = `customerTaxCode_${i < 9 ? '0' + (i + 1) : i + 1}`;
          customer[key] = customer.customerTaxCode ? customer.customerTaxCode.charAt(i) : '';
        }

        if (customer.customerIndividualOrRepresentativeIssuedDate
          || customer.customerIndividualOrRepresentativeIssuedDate !== '') {
          const customerIndividualOrRepresentativeIssuedDate = customer.customerIndividualOrRepresentativeIssuedDate.split('/');
          customer.customerIndividualOrRepresentativeIssuedDay = customerIndividualOrRepresentativeIssuedDate[0];
          customer.customerIndividualOrRepresentativeIssuedMonth = customerIndividualOrRepresentativeIssuedDate[1];
          customer.customerIndividualOrRepresentativeIssuedYear = customerIndividualOrRepresentativeIssuedDate[2];
          customer.customerIndividualOrRepresentativeIssuedShortYear = customerIndividualOrRepresentativeIssuedDate[2].slice(-2);
        }


        if (customer.customerBusinessCertificateIssuedDate || customer.customerBusinessCertificateIssuedDate !== '') {
          const customerBusinessCertificateIssuedDate = customer.customerBusinessCertificateIssuedDate.split('/');
          customer.customerBusinessCertificateIssuedDay = customerBusinessCertificateIssuedDate[0];
          customer.customerBusinessCertificateIssuedMonth = customerBusinessCertificateIssuedDate[1];
          customer.customerBusinessCertificateIssuedYear = customerBusinessCertificateIssuedDate[2];
        } else {
          customer.customerBusinessCertificateIssuedDay = '';
          customer.customerBusinessCertificateIssuedMonth = '';
          customer.customerBusinessCertificateIssuedYear = '';
        }

        if (callback) {
          callback(customer);
        }
      }
    });
  }
  public openAddCustomer() {
    this.customerDialog = this.dialog.open(AddCustomerDialogComponent, {
      width: '70%',
      data: true
    });

    this.customerDialog.componentInstance.createSuccess.asObservable().subscribe(() => {
      this.getCustomerById(this.documentService.getCustomerId(), false, (customer) => {
        this.RECORD_PARTY_SIGN = [
          ...this.RECORD_PARTY_SIGN,
          {
            enterpriseId: customer.customerId,
            order: this.valueAddPartyOrder,
            email: customer.customerEmail,
            enterpriseName: '',
            phone: customer.customerPhone,
            status: this.enumContractEnterpriseStatus.NO_PROCESS,
            isCreatedSide: false,
            customerId: this.documentService.getCustomerId(),
            name: customer.customerName,
            certificateNo: (customer.customerTaxCode.length > 0) ? customer.customerTaxCode : customer.customerCertificateNo,
            useDataForTemplate: false,
            isSignNoLogin: false,
            customerType : customer.customerType
          }
        ];

        this.createContractService.isDirty = true;
      });
    });
  }
  autocompletePartySelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedParty(model.enterpriseId, model.customerId)) {
        this.RECORD_PARTY_SIGN = [
          ...this.RECORD_PARTY_SIGN,
          {
            enterpriseId: model.enterpriseId,
            order: this.valueAddPartyOrder,
            email: model.email,
            enterpriseName: '',
            phone: model.phone,
            status: this.enumContractEnterpriseStatus.NO_PROCESS,
            isCreatedSide: model.isCreatedSide,
            customerId: model.customerId,
            name: model.name,
            certificateNo: (model.taxCode) ? model.taxCode : model.certificateNo,
            useDataForTemplate: false,
            isSignNoLogin: false,
            customerType : model.customerType,
          }
        ];

        this.inputPartyValue = '';
        this.filteredPartyOptions = [];
        this.valueAddPartyOrder = Math.max.apply(Math, this.RECORD_PARTY_SIGN.map((o) => {
          return o.order;
        })) + 1;

      } else {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_party_apostrophe_duplicate'), model.name));
      }
    }
  }
  onChangePartySignSearch($event: any): void {
    this.filteredPartyOptions = [];
    if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
      if (this.timeOutQueryServer) {
        clearTimeout(this.timeOutQueryServer);
      }
      this.timeOutQueryServer = setTimeout(() => {
        if (this.inputPartyValue.trim().length > 0) {
          this.nzCheckLoadingParty = true;
          this.autoEnterpriseService.fetchAuto(this.inputPartyValue.trim())
            .then(result => {
              // console.log('record party sign result', result);

              this.filteredPartyOptions = [];
              if (result) {
                for (const item of result) {
                  if(!item.isCreatedSide){
                    this.filteredPartyOptions.push(item);
                  }
                }
              }
              // this.filteredPartyOptions = result;
            }).finally(() => {
            this.nzCheckLoadingParty = false;
          });
        } else {
          this.inputPartyValue = '';
        }
      }, 500);

    }
  }
  onClickDeleteElementRecordInternalUserNew(id: any): void {

    this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.filter(d => d.customerId !== id);
  }
  autocompleteInternalUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedInternalUser(model.id)) {
        this.dataDocumentParent = [
          ...this.dataDocumentParent,
          {
            code: model.code,
            name: model.name,
            id: model.id,
            typeId:model.typeId,
            contractTerminationStatus: model.contractTerminationStatus,
            status: model.status
          }
        ];
        // console.log(this.RECORD_PARTY_SIGN);


        // this.setFormChanging(true);
        // this.inputPartyValue = '';
        // this.filteredPartyOptions = [];
        // this.createContractService.recordsInternalUsers.next(this.RECORD_INTERNAL_USER);

      } else {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_document_forward_duplicate'), model.name));
      }
    }
  }
  getParentContractNew(e, value?: string) {
    this.parentContracts = [];
    if (e.inputType.includes('insert') || e.inputType.includes('delete')) {
      if (!this.inputInternalDocumentsValue) {
        this.parentContracts = [];
        return;
      }
      if (this.timeOutQueryServer1) {
        clearTimeout(this.timeOutQueryServer1);
      }
      this.timeOutQueryServer1 = setTimeout(() => {
        const data = {
          nameOrCode: this.inputInternalDocumentsValue.trim(),
          contractId: this.contractId
        };
        this.isLoading = true;
        this.nzCheckLoadingParty1 = true;
        this.digitalContractService.getContractParent(data)
          .subscribe(res => {
            if (res.data && res.success) {
              this.parentContracts = res.data.filter(item => !item.isContractShare);
              const height = 45 * this.parentContracts.length;
              if (this.parentContracts.length) {
                if (height <= 250) {
                  this.listParentHeight = -(height + 2 - 30);
                } else {
                  this.listParentHeight = -220;
                }
              } else {
                this.listParentHeight = -17;
              }
            } else {
              this.toastr.error(res.message);
            }
            this.nzCheckLoadingParty1 = false;
            this.isLoading = false;

          });
      },500);
    } else return;
  }

  getParentContract(e, value?: string) {
    if (e.key === 'ArrowDown') {
      this.parentActive++;
      if (this.parentActive > this.parentContracts.length - 1) {
        this.parentActive = 0;
      }
    } else if (e.key === 'ArrowUp') {
      this.parentActive--;
      if (this.parentActive < 0) {
        this.parentActive = this.parentContracts.length - 1;
      }
    } else if (e.key === 'Enter') {
      if (this.parentActive >= 0 && this.parentActive <= this.parentContracts.length - 1) {
        this.parentContractChange('', true);
        return;
      }
    }
    if (/^([a-zA-Z0-9\s/"':;`~!@#$%^&*()_+=.?\[\]\}\{|\\><,-])$/.test(e.key) || e.key === 'Backspace' || value === '') {
      this.reset('docParent');
      if (!this.parentSelected.value) {
        this.parentContracts = [];
        return;
      }
      const data = {
        nameOrCode: this.parentSelected.value.trim(),
        contractId: this.contractId
      };
      this.isLoading = true;
      this.nzCheckLoadingParty1 = true;
      this.digitalContractService.getContractParent(data)
        .subscribe(res => {
          if (res.data && res.success) {
            this.parentContracts = res.data;
            const height = 45 * this.parentContracts.length;
            if (this.parentContracts.length) {
              if (height <= 250) {
                this.listParentHeight = -(height + 2 - 30);
              } else {
                this.listParentHeight = -220;
              }
            } else {
              this.listParentHeight = -17;
            }
          } else {
            this.toastr.error(res.message);
          }
          this.isLoading = false;
          this.nzCheckLoadingParty1 = false;

        });
    } else return;
  }

  parentContractChange(id, index?: boolean) {
    if (index) {
      this.mainFormAdd.controls.docParent.patchValue(this.parentContracts[this.parentActive].id);
      this.parentSelected.patchValue(this.parentContracts[this.parentActive].code + ' - ' + this.parentContracts[this.parentActive].name)
    } else {
      this.mainFormAdd.controls.docParent.patchValue(id);
      const parentSelected = this.parentContracts.filter(item => item.id === id);
      if (parentSelected.length > 0) {
        this.parentSelected.patchValue(parentSelected[0].code + ' - ' + parentSelected[0].name);
      }
    }

    if (this.mainFormAdd.controls.docParent.value) {
      this.digitalContractService.getContractById(this.mainFormAdd.controls.docParent.value).subscribe(res => {
        if (res.success) {
          this.mainFormAdd.controls.docType.patchValue(res.data.serviceType);
          this.mainFormAdd.controls.docType.disable();
        }
      })
    }
    this.mainFormAdd.markAsDirty();
  }

  dateFocusOut(field: string) {
    if (this.mainFormAdd.controls[field].errors
        && this.mainFormAdd.controls[field].errors.matDatepickerParse
        && this.mainFormAdd.controls[field].errors.matDatepickerParse.text === ''
    ) {
      this.mainFormAdd.controls[field].patchValue(null);
      if (field === 'expirationDate') {
        this.mainFormAdd.controls[field].setErrors(null);
      }
    }
  }

  async onSelectedUpload(event) {
    await this.getFile(event);
    event.target.value = null;
  }

  public async getFile(e) {
    this.blockUI.start();

    if (typeof FileReader !== 'undefined') {
      const files = e.target.files;
      let size = 0;
      const filesUpload = this.filesUpload ? this.filesUpload : [];
      const filesSrc = this.filesSrc ? this.filesSrc : [];
      const oldFiles = this.contractId ? this.mainFormAdd.controls.contractAttachments.value : [];
      let isErrorFileSize = false
      oldFiles.forEach(item => {
        size += item.fileSize;
      });
      filesUpload.forEach(item => {
        size += item.size;
      });
      files.forEach(item => {
        if(item.size > this.maxPerMainFile){
          isErrorFileSize = true
          return;
        }
        size += item.size;
      })
      if(isErrorFileSize){
        this.toastr.error(this.message.getMessage('validation.max_size_file_upload').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024))));
        this.blockUI.stop();
        return;
      }

      let filesName = this.filesName ? this.filesName : [];

      let error: 'type' | 'size' | 'count' = null;
      const type = ['application/pdf'];
      const tails = ['pdf'];
      if (files.length + filesUpload.length + oldFiles.length > 20) {
        error = 'count';
      } else if (size <= this.maxSizeSystem) {
        for (let file of files) {
          const fileName = file.name;
          const dotIndex = fileName.lastIndexOf('.');
          const namePart = fileName.substring(0, dotIndex);
          const extPart = fileName.substring(dotIndex + 1).toLowerCase();
          const newFileName  = `${namePart}.${extPart}`;
          file = new File([file], `${newFileName}`, { type: file.type })
          const nameSplit = file.name.split('.')
          const tail = nameSplit.pop();
          if (!type.includes(file.type) && !tails.includes(tail) && !(file.type == '' && tail == 'msg') && file.type.slice(0, 6) !== 'image/') {
            error = 'type';
            break;
          } else {
            const name = this.checkmatched(this.filesName, file.name);
            filesName.push(name);
            this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
              order: index,
              fileName: fileName
            }))];
            filesUpload.push(file);

            if (file.type === 'application/pdf') {
              const src = await this.checkContentTypeThenAddFile(file);
              filesSrc.push(src);
            } else {
              filesSrc.push('notPDF');
            }
          }
        }
      } else {
        error = 'size';
      }

      if (error) {
        switch (error) {
          case 'type':
            if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
              this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
              this.blockUI.stop();
            }
            break;
          case 'size':
            if (!this.toastr.findDuplicate(this.message.getMessage('validation.max_size_file_contract'), true, true)) {
              this.toastr.error(this.message.getMessage('validation.max_size_file_contract').replace('{0}', String(Math.floor(this.maxSizeSystem / 1024 / 1024))));
              this.blockUI.stop();
            }
            break;
          case 'count':
            if (!this.toastr.findDuplicate(this.message.getMessage('messages.files_less_20'), true, true)) {
              this.toastr.error(this.message.getMessage('messages.files_less_20'));
              this.blockUI.stop();
            }
            break;
          default:
            break;
        }
        this.blockUI.stop();
        return;
      } else {
        this.filesUpload = filesUpload;
        this.filesSrc = filesSrc;
        this.filesName = filesName;
        this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
          order: index,
          fileName: fileName
        }))];
        const fileOld = this.contractId ? this.mainFormAdd.controls['contractAttachments'].value : []
        this.mainFiles = [...fileOld, ...this.filesUpload]
      }
    }

    if (this.filesSrc.length > 0) {
      this.pdfSrc = this.filesSrc[this.activeFile];
    }

    this.blockUI.stop();
    return true;
  }

  public reset(feild: string) {
    this.mainFormAdd.controls[feild].reset('');

    if (feild === 'docParent') {
      this.mainFormAdd.controls.docType.enable();
    }
  }

  private checkmatched(listFileName: string[], name: string) {
    const filenameSplit = name.split('.')
    const type = filenameSplit.pop();
    const fileName = filenameSplit.join('.');
    let fileNameConverted = fileName + '.' + type;
    let k = 1;
    if (listFileName.length > 0) {
      while (listFileName.includes(fileNameConverted)) {
        fileNameConverted = fileName + '(' + k + ').' + type;
        k++;
      }
    }


    return fileNameConverted;
  }

  textLayerFormRendered(e) {
    const element = e.source.textLayerDiv;
    const pageIndex = e.source.pageNumber;
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}`);
  }

  private async checkContentTypeThenAddFile(file: File): Promise<boolean> {
    const ct = await FileUtils.getContentType(file);
    let r = null;
    if (ContentType.PDF === ct) {
      r = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        // tslint:disable-next-line:no-shadowed-variable
        reader.onload = (e: any) => {
          resolve(e.target.result);
        };
        reader.readAsArrayBuffer(file);
      });
    }
    return new Promise((resolve, reject) => resolve(r));
  }

  focusOut(field: string) {
    if (field !== 'parentSelected') {
      const value = this.mainFormAdd.controls[field].value.trim();
      this.mainFormAdd.controls[field].patchValue(value ? value : '');
      this.mainFormAdd.controls[field].markAllAsTouched();
    } else {
      if (!this.mainFormAdd.controls.docParent.value) {
        this.parentSelected.reset('');
        // this.parentContracts = [];
      }
    }
  }

  saveContract(isSign: boolean = false) {
    this.digitalContractService.checkBackup().subscribe(backupStatus => {
      if (backupStatus.message === 'OK') {
        this.mainFormAdd.markAllAsTouched();

        if (this.mainFormAdd.controls.docCode.hasError('matched')) {
          this.mainFormAdd.controls.docCode.setErrors(null);
        }

        if (this.mainFormAdd.invalid) {
          this.isViewFull = false;
          return;
        }

        const contractAttachments = this.contractId ? this.mainFormAdd.controls.contractAttachments.value : [];
        if (this.mainFormAdd.valid && (this.filesUpload.length > 0 || contractAttachments.length > 0)) {
          this.newFileOrders = [...[]];
          this.filesNameHaveOrder.forEach((fileNameHaveOrder) => {
            this.filesUpload.forEach((fileUpload) => {
              if(fileNameHaveOrder.fileName === fileUpload.name) {
                this.newFileOrders.push(fileNameHaveOrder.order);
              }
            });
          });
          this.filesAttachment.forEach((item, index) => {
            this.newFileAttachmentOrders.push(index)
          })
          const listParentId = [];
          if(this.dataDocumentParent.length >0){
            this.dataDocumentParent.forEach(ele =>{
              listParentId.push(ele.id);
            })
          }
          if(this.RECORD_PARTY_SIGN.length >0){
            this.RECORD_PARTY_SIGN.forEach(ele =>{
              delete ele.enterpriseName;
              delete ele.status;
              delete ele.customerType;
              delete ele.customerCode;
            })
          }
          const controls = this.mainFormAdd.controls;
          const formContract = {
            id: controls.id.value,
            code: controls.docCode.value,
            name: controls.docName.value,
            lstReferenceContractId: listParentId,
            enterpriseSign:this.RECORD_PARTY_SIGN,
            enterpriseId: localStorage.getItem('enterpriseId'),
            effectiveDate: controls.effectiveDate.value || null,
            expiredDate: controls.expirationDate.value || null,
            serviceType: controls.docType.value,
            description: controls.description.value,
            allowReferenceCustomerView: controls.allowReferenceCustomerView.value,
            newFileAttachmentOrders: this.newFileAttachmentOrders
          };


          if (this.contractId !== '') {
            formContract['listFileDelete'] = controls.listFileDelete.value;
            // formContract['contractAttachments'] = controls.contractAttachments.value;

            let contractAttachmentsNew = [];

            this.filesNameHaveOrder.forEach((fileNameHaveOrder) => {
              controls.contractAttachments.value.forEach((contractAttachment) => {
                if(fileNameHaveOrder.fileName === contractAttachment.fileName) {
                  contractAttachmentsNew.push({
                    ...contractAttachment,
                    attachmentOrder: fileNameHaveOrder.order
                  })
                }
              })
            });
            const listAttachments = [...contractAttachmentsNew];
            listAttachments.forEach(ele =>{
              delete ele.idDecrypt;
            });
            formContract['contractAttachments'] = listAttachments;
            formContract['newFileOrders'] = [...this.newFileOrders];

            this.digitalContractService.updateContract(JSON.stringify(formContract), this.filesUpload, this.filesAttachment)
              .subscribe(result => {
                console.log(this.filesUpload)
                if (result.data && result.success) {
                  localStorage.setItem('saveContract', 'true')
                  this.toastr.success(this.message.getMessage('messages.update_success'));
                  if(isSign){
                    this.router.navigate([`/home-enterprise/sign-digital-flow/${this.contractId}`], {queryParams: {goFrom: 'digitalCompany'}})
                  } else {
                    this.router.navigateByUrl('/home-enterprise/digital-business');
                  }
                } else if (result.code === ErrorCode.ActiveContract1) {
                  this.mainFormAdd.controls.docCode.setErrors({matched: true});
                } else if(result.code === ErrorCode.MaxSizeError){
                  this.maxSize = result.data > 0 ? result.data : 10*1024*1024;
                  this.toastr.error(result.message);
                  this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)))
                } else {
                  this.toastr.error(result.message);
                }
              });
          } else {
            this.digitalContractService.effectiveDateNewContract.next(null);
            formContract['newFileOrders'] = [...this.newFileOrders];
            this.digitalContractService.createContract(JSON.stringify(formContract), this.filesUpload, this.filesAttachment)
              .subscribe(result => {
                if (result.data && result.success) {
                  localStorage.setItem('saveContract', 'true')
                  this.toastr.success(this.message.getMessage('messages.add_success'));
                  this.digitalContractService.effectiveDateNewContract.next(controls.effectiveDate.value);
                  if(isSign){
                    this.router.navigate([`/home-enterprise/sign-digital-flow/${result.data}`], {queryParams: {goFrom: 'digitalCompany'}})
                  } else {
                    this.router.navigateByUrl('/home-enterprise/digital-business');
                  }
                } else if (result.code === ErrorCode.ActiveContract1) {
                  this.mainFormAdd.controls.docCode.setErrors({matched: true});
                } else if(result.code === ErrorCode.MaxSizeError){
                  this.maxSize = result.data > 0 ? result.data : 10*1024*1024;
                  this.toastr.error(this.message.getMessage('validation.digital_file').replace('{0}', String(Math.floor(this.maxSize / 1024 / 1024))));
                  this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)))
                } else {
                  this.toastr.error(result.message);
                }
              });
          }

        } else if (this.filesUpload.length === 0 && contractAttachments.length === 0) {
          this.toastr.error(this.message.getMessage('digital_contract.error.no_file_selected'));
        }
      }
      else {
        this.toastr.error(backupStatus.message)
        this.router.navigateByUrl('/home-enterprise/digital-business');
      }
    })

  }

  cancelAdd() {
    this.digitalContractService.effectiveDateNewContract.next(null);
    this.digitalContractService.isSearch.next(null);
    if (this.mainFormAdd.dirty) {
      const dialog = this.dialog.open(WarningComponent, {
        data: this.message.getMessage('messages.config_is_change'),
        width: '40%'
      });
      dialog.afterClosed().subscribe(ref => {
        if (ref) {
          if (!window.history.length) {
            this.router.navigateByUrl('/home-enterprise/digital-business');
          } else {
            this.location.back();
          }
        }
      });
      return;
    }
    if (!window.history.length) {
      this.router.navigateByUrl('/home-enterprise/digital-business');
    } else {
      this.location.back();
    }
  }

  changeFile(index: number) {
    this.pdfSrc = this.filesSrc[index];
    this.activeFile = index;
  }

  removeFile(index: number) {
    if (this.contractId) {
      const oldFiles = this.mainFormAdd.controls.contractAttachments.value;
      const fileDeletes = this.mainFormAdd.controls.listFileDelete.value;
      if (index > oldFiles.length - 1) {
        this.filesUpload.splice(index - oldFiles.length, 1);
      } else {
        const fileDelete = oldFiles.splice(index, 1);
        this.mainFormAdd.controls.contractAttachments.patchValue(oldFiles);
        fileDeletes.push(fileDelete[0]);
        this.mainFormAdd.controls.listFileDelete.patchValue(fileDeletes);
      }
    } else {
      this.filesUpload.splice(index, 1);
    }
    this.filesName.splice(index, 1);

    this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
      order: index,
      fileName: fileName
    }))];

    this.newFileOrders = [...[]];
    this.filesNameHaveOrder.forEach((fileNameHaveOrder) => {
      this.filesUpload.forEach((fileUpload) => {
        if(fileNameHaveOrder.fileName === fileUpload.name) {
          this.newFileOrders.push(fileNameHaveOrder.order)
        }
      });
    });

    const fileOld = this.contractId ? this.mainFormAdd.controls['contractAttachments'].value : []
    this.mainFiles = [...fileOld, ...this.filesUpload]
    this.filesSrc.splice(index, 1);
    if (this.activeFile === index) {
      this.pdfSrc = this.filesSrc[0];
      this.activeFile = 0;
    } else if (this.activeFile > index) {
      this.activeFile -= 1;
    }
    this.pdfSrc = this.filesSrc[this.activeFile];
    if (this.filesSrc.length === 0) {
      this.pdfSrc = null;
    }
  }

  private initData(id: string) {
    this.blockUI.start();
    this.digitalContractService.getContractById(id).subscribe(async res => {
      if (res.data && res.success) {
        const data = res.data;
        this.userType = JSON.parse(localStorage.getItem('userType'));
        if (this.userType === 1 || data.isEditable) {
          this.isShowUpdate = true;
        } else {
          this.isShowUpdate = false;
        }
        if (data.parentId) {
            this.parentSelected.patchValue(data.parentCode + ' - ' + data.parentName);
            this.affiliateContract.push({code: data.parentCode, name: data.parentName, id: data.parentId});
        } else if (this.mode !== 'create') {
            this.affiliateContract = [{code: data.parentCode, name: data.parentName, id: data.parentId}]
        }
        const serviceType = this.docType.filter(type => type.id === data.serviceType)
        const attachments = res.data.contractAttachments.filter(item => item.AttachmentType == 40000);
        this.docInfos = res.data.contractAttachments.filter(item => item.AttachmentType == 40000);
        this.filesAttachment = res.data.contractAttachments.filter(item => item.AttachmentType !== 40000);
        this.filesAttachmentOld = res.data.contractAttachments.filter(item => item.AttachmentType !== 40000);
        this.contractStatus = res.data.status;
        this.mainFiles = res.data.contractAttachments.filter(item => item.AttachmentType == 40000)
        if(res.data.contractEnterpriseCreated){
          this.contractEnterpriseCreated = [{
            ...res.data.contractEnterpriseCreated,
            signMetadata: res.data.contractEnterpriseCreated.signMetadata ? JSON.parse(res.data.contractEnterpriseCreated.signMetadata) : {}
          }]
        }
        this.createdBy = res.data.createdBy
        if (attachments.length > 0) {
          this.blockUI.start();
          for (let file of attachments) {
            this.filesName.push(this.checkmatched(this.filesName, file.fileName));
            this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
              order: index,
              fileName: fileName
            }))];
            const type = file.fileName.split('.').pop();
            if (type === 'pdf') {
              const pdfSrc = await this.viewDocumentUpload(file.id, file.fileName, file.fileSize);
              this.filesSrc.push(pdfSrc);

              this.pdfSrc = this.filesSrc[0];
            } else {
              this.filesSrc.push('notPDF');
              this.pdfSrc = this.filesSrc[0];
            }
          }
          this.blockUI.stop();
        }
        this.dataDocumentParent = res.data.parents;
        const listUser = [];
        if(res.data.contractEnterprise && res.data.contractEnterprise.length > 0){
          res.data.contractEnterprise.forEach(ele =>{
            listUser.push({
              enterpriseId: ele.enterpriseId || "",
              order: ele.order|| "",
              email: ele.enterpriseEmail|| "",
              enterpriseName: "",
              phone: ele.enterprisePhone || "",
              status: 1,
              isCreatedSide: ele.createdSide || "",
              customerId: ele.customerId || "",
              customerCode:ele.customerCode || "",
              name: ele.enterpriseName || "",
              certificateNo: ele.certificateNo || "",
              useDataForTemplate: false,
              isSignNoLogin: ele.isSignNoLogin || "",
              signConfig: null,
              customerType : null})
          })
        }
        this.RECORD_PARTY_SIGN = listUser;
        const formatWay = this.mode === 'view' ? 'DD/MM/YYYY' : null;
        this.mainFormAdd.patchValue({
          id,
          docType: this.mode === 'view' ? serviceType[0].name : data.serviceType,
          docParent: data.parentId,
          docName: data.name,
          docCode: data.code,
          effectiveDate: data.effectiveDate ? format(format(data.effectiveDate, 'MMM DD, YYYY HH:mm:ss A'), formatWay) : '',
          expirationDate: data.expiredDate ? format(format(data.expiredDate, 'MMM DD, YYYY HH:mm:ss A'), formatWay) : '',
          description: data.description,
          allowReferenceCustomerView: data.allowReferenceCustomerView
        });

        if (this.mainFormAdd.controls.docParent.value) {
          this.mainFormAdd.controls.docType.disable();
        }

        this.mainFormAdd.addControl('contractAttachments', new FormControl(data.contractAttachments.filter(item => item.AttachmentType == 40000)));
        this.mainFormAdd.addControl('listFileDelete', new FormControl([]));
      } else {
        this.toastr.error(res.message);
        this.router.navigateByUrl('/home-enterprise/digital-business');
        this.blockUI.stop();
      }
    });
    this.blockUI.stop();
  }
  onClickDeleteElementRecordInternalUser(id: any): void {

    this.dataDocumentParent = this.dataDocumentParent.filter(d => d.id !== id);
  }

  public viewDocumentReference(res) {
    // public getParentDocumentById() {
    this.documentService.getDocumentById(res.id).subscribe(rs => {
      if(!rs.success){
        this.toastr.error(rs.message);
      }
      else {
        this.selectedDocumentTypeParent = {
          id: rs.data.contractDTO.id,
          name: rs.data.contractDTO.name,
          code: rs.data.contractDTO.code,
          filePath: rs.data.contractDTO.filePath
        };
        const data: ViewDocumentReferenceDto = {
          mainContractId: null,
          referenceContractId: res.id,
          pdfFilePath: this.selectedDocumentTypeParent.filePath
        };
        this.isViewParentContract = true;
        if (this.selectedDocumentTypeParent && this.selectedDocumentTypeParent.id) {
          const dialogRef = this.dialog.open(ViewDocumentReferenceComponent, {
            width: '90%',
            minHeight: '90%',
            data,
          });
          dialogRef.afterClosed().subscribe(rs => {
            this.isViewParentContract = false;
          });
        } else {
          if (!this.toastr.findDuplicate(this.message.getMessage('messages.not_documentId'), true, true)) {
            this.toastr.error(this.message.getMessage('messages.not_documentId'));
          }
        }
      }

    });
    // }

  }
  viewContract(ala,data?) {
    if(ala.typeId == 2){
      this.blockUI.start();
      this.digitalContractService.getContractById(ala.id).subscribe(async res => {
        if (res.data && res.success) {
          this.contractView.contractName = res.data.code + ' - ' + res.data.name;
          const attachments = res.data.contractAttachments;
          if (attachments.length > 0) {
            this.blockUI.start();
            const nameList = [];
            const idList = [];
            const listFileSize = [];

            for (let file of attachments) {
              nameList.push(this.checkmatched(nameList, file.fileName));
              idList.push(file.id)
              listFileSize.push(file.fileSize)
              console.log(file, 'file file');
              if (idList.length === attachments.length) {
                this.blockUI.stop();
              }
            }
            this.contractView.filesName = nameList;
            this.contractView.id = idList;
            this.contractView.listFileSize = listFileSize;
            this.isViewParentContract = true;
            this.contractView.idDocument = ala.id;
            this.contractView.attachments = attachments;
            if(data){
              this.contractView.checkMan = data;
            }
            const dialog = this.dialog.open(ViewContractComponent, {
              data: this.contractView,
              width: '90%',
              minHeight: '90%'
            });
            dialog.afterClosed().subscribe(res => {
              this.isViewParentContract = false;
            })
            // this.blockUI.stop();

          }
        } else {
          this.toastr.error(res.message);
        }
      });
      this.blockUI.stop();

    }
    else{
      this.viewDocumentReference(ala);
    }

  }

  async viewDocumentUpload(id, fileName, size?) {
    let pdfSrc;
    if (!this.env.pdfViewFullDownload && size && size > LIMIT_SIZE) {
      pdfSrc = `${this.BASE_URL}/${id}`;
    } else {
      const res = await this.digitalContractService.getContractFiles(id).toPromise();
      pdfSrc = await this.showPdf(res, fileName);
    }
    return pdfSrc;
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  async showPdf(blob: any, fileName: string) {
    const file = this.blobToFile(blob, fileName);
    const pdfSrc = await this.commonService.readFileAsync(file);
    return pdfSrc;
  }

  downloadContract() {
    this.digitalContractService.downloadContractFail(this.contractId).subscribe(error => {
      if (error.success === false) {
        this.toastr.error(error.message);
        return;
      }
      if (error) {
        this.digitalContractService.downloadContract(this.contractId).subscribe(res => {
          if (window.top.navigator.msSaveOrOpenBlob) {
            // Store Blob in IE
            window.top.navigator.msSaveOrOpenBlob(res, this.mainFormAdd.controls.docName.value + '.zip');
          } else {
            // Store Blob in others
            const tA = document.body.appendChild(document.createElement('a'));
            tA.href = window.URL.createObjectURL(res);
            tA.download = this.mainFormAdd.controls.docCode.value + ' - ' + this.mainFormAdd.controls.docName.value + '.zip';
            tA.style.display = 'none';
            tA.click();
            tA.parentNode.removeChild(tA);
          }
        });
      }
    })
  }
  someMethod(e) {}

  moveToUpdate() {
    this.router.navigateByUrl(`/home-enterprise/digital-business/${this.contractId}/update`);
  }
  async doPrint() {

    this.isLoading = true;
    this.nzCheckLoadingParty1 = true;

    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }

    if(this.isString(this.pdfSrc)){
      if(this.pdfSrc =='notPDF'){
        this.toastr.error(this.translateService.instant('messages.notPdf'))
        return
      }else if(this.pdfSrc.includes('view/digital/view-file')&&this.docInfos[this.activeFile].fileSize > LIMIT_SIZE){
        this.callApiWaterMark();
        return
      }
    }

     if(this.pdfSrc.byteLength == undefined||this.pdfSrc.byteLength == 0){
      this.toastr.error(this.translateService.instant('messages.errorPdf'))
      return
    }

      this.pdfSrc = this.filesSrc[this.activeFile];
      const buffer = this.pdfSrc;
      const blob = new Blob([buffer], {
        type: 'application/pdf'
      });
      const objectURL = URL.createObjectURL(blob);

      // Create an iframe to demonstrate it:
      const iframe = document.createElement('iframe');
      iframe.id = 'sample-iframe';
      iframe.src = objectURL;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
      this.isLoading = false;
    this.nzCheckLoadingParty1 = false;
      iframe.hidden = true

  }
  isString(value) {
    return typeof value === "string";
  }
  async callApiWaterMark(){
    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }

    let a = this.mainFormAdd.value.contractAttachments[this.activeFile].id

   await this.documentService.getDocWithWaterMarkV2(this.contractId,a).subscribe( async (response: any) => {
      if(await response){
        this.markPdf =  await this.commonService.readFileAsync(response);
      }
      // Create the Blob URL:
      const buffer = this.markPdf;
      const blob = new Blob([buffer], {
        type: 'application/pdf'
      });
      const objectURL = URL.createObjectURL(blob);

      // Create an iframe to demonstrate it:
      const iframe = document.createElement('iframe');
      iframe.id = 'sample-iframe';
      iframe.src = objectURL;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
      iframe.hidden = true
    },(error:HttpErrorResponse)=>{
      this.toastr.error(this.translateService.instant('messages.notGetPdf'))
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    let arraySrcBeforeMoveFile = [...[]];
    let arraySrcAfterMoveFile = [...[]];
    let filesUploadNew = [...[]];

    this.filesName.forEach((fileName, indexFileName) => {
      this.filesSrc.forEach((fileSrc, indexFileSrc) => {
        if(indexFileName === indexFileSrc) {
          arraySrcBeforeMoveFile.push({
            src: fileSrc,
            fileName: fileName
          });
        }
      })
    });

    moveItemInArray(this.filesName, event.previousIndex, event.currentIndex);
    if(this.activeFile === event.previousIndex) {
      this.activeFile = event.currentIndex;
    } else if(event.previousIndex > this.activeFile && event.currentIndex <= this.activeFile) {
      this.activeFile = this.activeFile + 1;
    } else if(event.previousIndex < this.activeFile && event.currentIndex >= this.activeFile) {
      this.activeFile = this.activeFile - 1;
    } else {
      console.log(this.filesName);
    }

    this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
      order: index,
      fileName: fileName
    }))];

    this.filesName.forEach((fileName) => {
      this.filesUpload.forEach((fileUpload) => {
        if(fileName === fileUpload.name) {
          filesUploadNew.push(fileUpload);
        }
      })
    });

    this.filesName.forEach((fileName) => {
      arraySrcBeforeMoveFile.forEach((fileSrc) => {
        if(fileName === fileSrc.fileName) {
          arraySrcAfterMoveFile.push(fileSrc.src);
        }
      })
    });

    this.newFileOrders = [...[]];
    this.filesNameHaveOrder.forEach((fileNameHaveOrder2) => {
      this.filesUpload.forEach((fileUpload2) => {
        if(fileNameHaveOrder2.fileName === fileUpload2.name) {
          this.newFileOrders.push(fileNameHaveOrder2.order);
        }
      });
    });

    if(this.contractId) {
      this.filesNameHaveOrder.forEach((fileNameHaveOrder) => {
        this.docInfos.forEach((contractAttachment) => {
          if(fileNameHaveOrder.fileName === contractAttachment.fileName) {
            this.contractAttachmentsNew.push({
              ...contractAttachment,
              attachmentOrder: fileNameHaveOrder.order
            });
          }
        })
      });
    }

    this.filesUpload = [...filesUploadNew];
    this.filesSrc = [...arraySrcAfterMoveFile];
  }

  changeFileAttachment(event){
    if(event && event.length > 0){
      this.filesAttachment = event
    }
  }

  deleteFileAttachment(event){
    if(event){
      const fileDeletes = this.mainFormAdd.controls.listFileDelete.value;
      fileDeletes.push(event)
      this.mainFormAdd.controls.listFileDelete.patchValue(fileDeletes);
    }
  }

  downloadFile(id, name) {
    this.commonService.downloadDocumentFile(id,'?type=DIGITAL').subscribe(rs => {
      this.downLoadFile(rs, 'application/octet-stream', name);
    });
  }

  /**
   * Method is use to download file.
   * @param data - Array Buffer data
   * @param type - type of the document.
   * @param fileName - file name of file
   */
  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  goToSign(){
    this.router.navigate([`/home-enterprise/sign-digital-flow/${this.contractId}`], {queryParams: {goFrom: 'digitalCompany'}})
  }

  isCreated(){
    const userId = localStorage.getItem('userId')
    return userId == this.createdBy || false
  }
  createdBy: any = ''
  protected readonly enumApproverStatus = EnumApproverStatus;
}
